module.exports = __webpack_public_path__ + "static/media/conner-result.463c9d34.png";